import PasswordRecovery from '../components/PasswordRecovery'
export default function ForgotPassword() { return <PasswordRecovery /> }
